<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>EDIT CATEGORY</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <!-- TITLE -->
        <i8n-input label="Title" :content.sync="data.title" class="mt-5 w-full" name="item-name" v-validate="'required'" />

        <!-- DESC -->
        <i8n-input label="Description" :content.sync="data.description" class="mt-5 w-full" name="item-name" v-validate="'required'" />

        <!-- TAGS -->
        <div class="vx-col w-full mt-6">
          <label class="vs-input--label">Tags (optional)</label>
        </div>
        <div class="vx-row mb-6 mt-2">
          <div class="vx-col w-full">
            <vs-chips placeholder="New Tag" v-model="data.tags" style="width: 100%">
              <vs-chip
                color="#24c1a0"
                :key="tag"
                @click="removeTag(tag)"
                v-for="tag in data.tags" closable>
                {{ tag }}
              </vs-chip>
            </vs-chips>
            <p style="font-weight:600;font-size:85%;margin-top:8px;">
              User will see the Article Category when the country tag and at least one other tag matches the user tags. 
            </p>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div  v-if="data" id="single-image-container" class="vx-col lg:w-1/1 w-full">
            <h5>Photos</h5>
            <div ref="articleCategoryImagesContainer">
              <!--<ArticleCategoryImages :articleCategory="data" />-->
            </div>
          </div>
        </div>

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import Vue from 'vue'

import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import ArticleCategoryImages from './ArticleCategoryImages.vue';

//const ArticleCategoryImages = () => import("./ArticleCategoryImages.vue");

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    ArticleCategoryImages
  },
  data () {
    return {

      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    itemId (/*val*/) {
      var ArticleCategoryImagesClass = Vue.extend(ArticleCategoryImages);
      
      var instance = new ArticleCategoryImagesClass({
          propsData: { articleCategory: this.data }
      });
      instance.$mount();

      while (this.$refs.articleCategoryImagesContainer.hasChildNodes()) {
        this.$refs.articleCategoryImagesContainer.removeChild(this.$refs.articleCategoryImagesContainer.lastChild);
      }

      this.$refs.articleCategoryImagesContainer.appendChild(instance.$el)
    }
  },
  computed: {
    itemId () {
      return this.data.articleCategoryId;
    },
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.data && this.data.title
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    submitData () {
      this.data.isSubmitted = true;
      this.$emit('closeSidebar')
    },

    removeTag (item) {
      this.data.tags.splice(this.data.tags.indexOf(item), 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
